<template>
  <div ref="nav" class="nav-list" :class="headerStyle" :style="{ marginRight: marginRight + 'px' }">
    <ul class="items">
      <li
        class="item"
        :class="{
          'router-link-active': nav.isActive,
          'has-child': nav.children && nav.children.length,
        }"
        @click="goTo(nav)"
        v-for="nav in topNavigates"
        :key="nav.id"
        @mouseover="onMouseOver($event, nav)"
        @mouseleave="onMouseLeave($event)"
      >
        <span class="name">{{ nav.name }}</span>
        <template v-if="nav.children && nav.children.length">
          <span class="arrow" v-if="headerStyle !== 'headerIndex headerDefault'"></span>
          <span class="arrow1" v-else></span>
          <ul class="item-child-container">
            <li
              class="item-child"
              :class="{
                'item-child-active': child.isActive,
              }"
              v-for="child in nav.children"
              :key="child.id"
              @click.stop="goTo(child)"
            >
              <span>{{ child.name }}</span>
            </li>
          </ul>
        </template>
      </li>
    </ul>
    <div v-if="surplusNaviagtes.length" class="item li-more">
      <div class="menu-more"></div>
      <ul class="ul_item">
        <li
          class="dropdown-item"
          :class="{
            'dropdown-item-active': nav.isActive,
          }"
          v-for="nav in surplusNaviagtes"
          :key="nav.id"
          @click="goTo(nav)"
        >
          {{ nav.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeaderMenu',
  props: {
    headerStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      marginRight: 54,
    };
  },
  computed: {
    url() {
      let { href } = this.$router.resolve({
        path: this.$route.path,
        params: this.$route.params,
        query: this.$route.query,
      });
      return document.location.origin + href;
    },
    navigates() {
      return this.$store.state.navigates;
    },
    dynamicNavigates() {
      let navigates = this.navigates;
      navigates.forEach((nav) => {
        nav.isActive = this.isActive(nav);
        if (nav.children) {
          nav.children.forEach((child) => {
            this.$set(child, 'isActive', this.isActive(child));
          });
        }
      });
      return navigates;
    },
    // 有口号放6个菜单，否则放8个菜单
    navLength() {
      return this.$store.state.webConfig.web_slogan ? 6 : 8;
    },
    topNavigates() {
      if (this.dynamicNavigates.length <= this.navLength) {
        return this.dynamicNavigates;
      } else {
        return this.dynamicNavigates.slice(0, this.navLength - 1);
      }
    },
    surplusNaviagtes() {
      if (this.dynamicNavigates.length <= this.navLength) {
        return [];
      } else {
        return this.dynamicNavigates.slice(this.navLength - 1);
      }
    },
  },
  async created() {
    // 路由守卫进入Index首页是已经请求过，此处判断用于防止重复
    if (this.$route.name != 'Index') {
      let navigates = await this.$http.get('/api/app/navigator');
      navigates.forEach((t) => {
        t.isActive = false;
      });
      this.$store.commit('setNavigates', [...navigates]);
    }
  },
  methods: {
    isActive(nav) {
      let flag = !this.$route.query.nav || this.$route.query.nav == nav.id;
      if (nav.is_outer == 1) {
        return this.url.indexOf(nav.url.split('?')[0]) >= 0 && flag;
      } else {
        return this.$route.path.indexOf(nav.url.split('?')[0]) == 0 && flag;
      }
    },
    goTo(nav) {
      let target = nav.is_target == 1 ? '_blank' : '_self';
      let url = nav.url;
      if (url.indexOf('?') < 0) {
        url += '?';
      } else {
        url += '&';
      }
      url += 'nav=' + nav.id;
      if (nav.is_outer == 1 || nav.is_target == 1) {
        window.open(url, target);
      } else if (this.$route.path == url) {
        this.$router.go(0);
      } else {
        this.$router.push({ path: url });
      }
    },
    onMouseOver($event, nav) {
      if (!nav.children || nav.children.length == 0) {
        return;
      }
      let item = $event.target;
      if (item.classList.contains('name') || item.classList.contains('arrow')) {
        item = item.parentNode;
      }
      if (!item.classList.contains('item')) {
        return;
      }
      let container = item.querySelector('.item-child-container');
      if (!container) {
        return;
      }
      container.style.height = nav.children.length * 50 + 'px';
    },
    onMouseLeave($event) {
      let item = $event.target;
      if (item.classList.contains('name') || item.classList.contains('arrow')) {
        item = item.parentNode;
      }
      if (!item.classList.contains('item')) {
        return;
      }
      let container = item.querySelector('.item-child-container');
      if (!container) {
        return;
      }
      container.style.height = '0';
    },
    setWidth(width) {
      let navWidth = this.$refs.nav.offsetWidth;
      let marginRight = width - navWidth;
      if (marginRight < 10) {
        marginRight = 10;
      } else if (marginRight > 54) {
        marginRight = 54;
      }
      this.marginRight = marginRight;
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-list {
  float: left;
  display: flex;

  .items {
    display: flex;
  }

  .item {
    margin-right: 36px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
    a {
      display: block;
    }
    span {
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
    }
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      .item-child-container {
        border-width: 1px;
      }
      span {
        color: $primary-color;
      }
      .arrow {
        background-image: url('~@/assets/images/common/arrow-down-theme@2x.png');
        transform: rotate(180deg);
      }
    }
    .arrow {
      width: 14px;
      height: 8px;
      display: inline-block;
      margin-left: 7px;
      background-image: url('~@/assets/images/common/arrow-down@2x.png');
      background-size: 100% 100%;
      vertical-align: 1px;
      transform: rotate(0deg);
      transition: 0.3s transform;
    }
    .arrow1 {
      width: 16px;
      height: 15px;
      display: inline-block;
      margin-left: 7px;
      background-image: url('~@/assets/images/common/arrow-down2@2x.png');
      background-size: 100% 100%;
      background-position-y: 2px;
      vertical-align: 1px;
      transform: rotate(0deg);
      transition: 0.3s transform;
    }
    &.router-link-active {
      span {
        color: $primary-color;
      }
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 3px;
        background: $primary-color;
        border-radius: 1px;
        left: 50%;
        transform: translateX(-50%);
        top: 50px;
      }
      .arrow {
        background-image: url('~@/assets/images/common/arrow-down-theme@2x.png');
      }
    }
  }

  .item-child-container {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    width: 136px;
    text-align: center;
    border-radius: 0 0 5px 5px;
    transition: height 0.3s;
    height: 0;
    overflow: hidden;

    .item-child {
      width: 136px;
      line-height: 50px;
      background: rgba($color: white, $alpha: 0.9);

      &:last-child {
        border-radius: 0 0 5px 5px;
      }

      span {
        color: #333333;
        font-weight: 400;
        font-size: 16px;
      }

      &:hover {
        background: white;

        span {
          color: $primary-color;
        }
      }
    }

    .item-child-active {
      background: white;

      span {
        color: $primary-color;
      }
    }
  }
}

.li-more {
  padding-right: 0 !important;
  margin: 0 40px 0 43px;
  .menu-more {
    width: 22px;
    height: 22px;
    position: relative;
    top: 24px;
    transition: max-height 0.2s;
    transform: translate(-50%, 0);
    background-image: url('~@/assets/images/common/Frame3020@2x.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 22px 22px;
    vertical-align: -5px;
  }
  ::v-deep {
    .el-dropdown {
      vertical-align: 2px;
    }
  }
  .ul_item {
    display: none;
  }
}
.li-more:hover {
  .ul_item {
    position: absolute;
    width: 136px;
    top: 70px;
    left: -65px;
    height: auto;
    display: block;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 0px 0px 6px 6px;
    box-shadow: 0px 30px 80px 0px rgba(0, 0, 0, 0.06);
    li {
      color: #333;
      display: block;
      cursor: pointer;
      height: 48px;
      line-height: 48px;
    }
    li:hover {
      color: $primary-color;
      background: #fff;
    }
  }
}
.headerDefault {
  .items {
    .name {
      color: rgba(255, 255, 255, 0.8);
    }
    .router-link-active {
      span {
        color: #fff;
      }
      &::after {
        background: #fff;
      }
    }
  }
  .menu-more {
    background-image: url('~@/assets/images/common/Frame3019@2x.png');
    background-size: 22px 22px;
  }
}
</style>
